function sliderCollapsibleTabs (sliders) {
    sliders.forEach((slider) => {
        const slides = slider.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)');

        // Slider
        const sliderOptions = {
            modules: [window.FoxTheme.Swiper.Navigation, window.FoxTheme.Swiper.Pagination],
            slidesPerView: 1,
            spaceBetween: 20,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: slider.querySelector('.swiper-btn-next'),
                prevEl: slider.querySelector('.swiper-btn-prev'),
            },
            loop: slides.length > 1,
        };

        const sliderInstance = new FoxTheme.Swiper.Swiper(slider, sliderOptions);
        sliderInstance.init();

        // Zoom
        let dataSource = [];
        slides.forEach((media) => {
            switch (media.dataset.mediaType) {
                case 'model':
                    dataSource.push({
                        id: media.dataset.mediaIndex,
                        html: `<div class="pswp__item--${media.dataset.mediaType}">${
                            media.querySelector('product-model').outerHTML
                        }</div>`,
                        mediaType: media.dataset.mediaType,
                    });
                    break;
                case 'video':
                case 'external_video':
                    dataSource.push({
                        id: media.dataset.mediaIndex,
                        html: `<div class="pswp__item--${media.dataset.mediaType}">${
                            media.querySelector('video-element').outerHTML
                        }</div>`,
                        mediaType: media.dataset.mediaType,
                    });
                    break;
                case 'image':
                    dataSource.push({
                        id: media.dataset.mediaIndex,
                        src: media.dataset.src,
                        width: media.dataset.pswpWidth,
                        height: media.dataset.pswpHeight,
                        mediaType: media.dataset.mediaType,
                    });
                    break;
            }
        });
        this.lightbox = new window.FoxTheme.PhotoSwipeLightbox({
            dataSource: dataSource,
            pswpModule: window.FoxTheme.PhotoSwipe,
            bgOpacity: 1,
            arrowPrev: false,
            arrowNext: false,
            zoom: false,
            close: false,
            counter: false,
            preloader: false,
        });

        this.lightbox.on('change', () => {
            window.pauseAllMedia(this);
            if (this.sliderInstance && this.sliderInstance.slider) {
                const { currIndex } = this.lightbox.pswp;
                if (this.sliderInstance.slider.realIndex !== currIndex) {
                    this.sliderInstance.slider.slideToLoop(currIndex, 100, false);
                }
            }
        });

        this.lightbox.on('pointerDown', (e) => {
            if (this.lightbox.pswp.currSlide.data.mediaType != 'image') {
                e.preventDefault();
            }
        });

        this.lightbox.on('uiRegister', () => {
            if (dataSource.length > 1) {
                this.lightbox.pswp.ui.registerElement({
                    name: 'next',
                    ariaLabel: 'Next slide',
                    order: 3,
                    isButton: true,
                    html: '<svg class="pswp-icon-next flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
                    onClick: (event, el) => {
                        this.lightbox.pswp.next();
                    },
                });
                this.lightbox.pswp.ui.registerElement({
                    name: 'prev',
                    ariaLabel: 'Previous slide',
                    order: 1,
                    isButton: true,
                    html: '<svg class="pswp-icon-prev rtl-flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50  L 65,10 L 60,0 Z"></path></svg>',
                    onClick: (event, el) => {
                        this.lightbox.pswp.prev();
                    },
                });
            }
            this.lightbox.pswp.ui.registerElement({
                name: 'close-zoom',
                ariaLabel: 'Close zoom image',
                order: 2,
                isButton: true,
                html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
                onClick: (event, el) => {
                    this.lightbox.pswp.close();
                },
            });
        });

        this.lightbox.init();

        const zoomCtas = slider.querySelectorAll('.js-photoswipe--zoom');
        zoomCtas.forEach((zoomCta) => {
            zoomCta.addEventListener('click', (e) => {
                const media = e.target;
                const index = Number(media.dataset.mediaIndex) || 0;
                this.lightbox.loadAndOpen(index);
            });
        });
    });
}
const sliders = document.querySelectorAll('.collapsible-tabs__slider');
sliderCollapsibleTabs (sliders);
